<mat-form-field *ngIf="vm$ | async; let vm" [color]="vm.color$ || 'accent'" style="width:100%">
    <mat-label *ngIf="vm.label$">{{ vm.label$ }}</mat-label>
    
    <input matInput [placeholder]="vm.placeholder$" [formControl]="formControl" [required]="vm.required$"
        [matAutocomplete]="auto1">

    <mat-autocomplete
        #auto1="matAutocomplete" [displayWith]="vm.displayWith$" (opened)="vm.options$ ? null : showOptions()">
        
        <ng-container *ngIf="vm.options$; else loading">
            <mat-option *ngFor="let option of vm.options$" 
                [value]="option">
                {{ (vm.displayWith$ | func : option) || option }}
            </mat-option>
        </ng-container>
        <ng-template #loading>
            <mat-option>
                Laster inn...
            </mat-option>
        </ng-template>
        
    </mat-autocomplete>

    <mat-hint *ngIf="vm.hint$">{{ vm.hint$ }}</mat-hint>

    <button mat-icon-button matSuffix *ngIf="vm.resetable$ && formControl && !formControl.disabled && formControl.value" aria-label="Clear" 
        (tap)="resetValue()">
        <mat-icon>close</mat-icon>
    </button>

    <mat-error *ngIf="formControl && formControl.dirty && formControl.invalid">
        {{ getValidationErrorMessage() }}
    </mat-error>
</mat-form-field>